<template>
  <div class="flex items-center cursor-pointer">
    <div class="flex items-center h-5">
      <input
        v-bind="$attrs"
        :id="id"
        type="radio"
        :value="value"
        :checked="isChecked"
        class="focus:ring-alo-400 h-4 w-4 text-alo-600 border-gray-300"
        :class="{ 'with-errors': error }"
        @change="$emit('change', $event.target.value)"
      />
    </div>
    <div class="ml-3 text-sm">
      <label :for="id" class="font-medium text-gray-700 select-none cursor-pointer">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'change',
  },

  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    id: {
      type: String,
      default: () => 'checkbox-' + Math.floor(Math.random() * 100000),
    },
    error: {
      type: Object,
      default: null,
    },
  },

  computed: {
    isChecked() {
      return this.modelValue === this.value
    },
  },
}
</script>
